import React, { Component } from 'react';

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: null
  };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleGoHome = () => {
    window.location.replace('/home');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8f9fa',
            padding: '20px',
            fontFamily: 'Poppins, sans-serif'
          }}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '20px',
              padding: '40px 30px',
              maxWidth: '350px',
              width: '100%',
              textAlign: 'center',
              boxShadow: '0px 10px 40px rgba(114, 45, 210, 0.15)'
            }}
          >
            {/* Error Icon */}
            <div
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: 'rgba(114, 45, 210, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px'
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="#722dd2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {/* Title */}
            <h2
              style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#1a1a2e',
                marginBottom: '12px'
              }}
            >
              Oops! Something went wrong
            </h2>

            {/* Description */}
            <p
              style={{
                fontSize: '14px',
                color: '#8F92A1',
                marginBottom: '30px',
                lineHeight: '1.6'
              }}
            >
              We encountered an unexpected error. Please try again.
            </p>

            {/* Go Home Button */}
            <button
              onClick={this.handleGoHome}
              style={{
                width: '100%',
                height: '50px',
                backgroundColor: '#722dd2',
                color: '#ffffff',
                border: 'none',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0px 4px 15px rgba(114, 45, 210, 0.3)'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#5a23a8';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#722dd2';
              }}
            >
              Go to Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
